<!-- [variant]="'on'" -->
<p-floatlabel class="flex grow" [variant]="floatLabelVariant()">
    <p-datepicker
        [focusTrap]="false"
        [autofocus]="false"
        [inputStyle]="inputStyle()"
        id="{{ id() }}"
        [showClear]="showClear()"
        [showTime]="showTime()"
        [showIcon]="showIcon()"
        [appendTo]="'body'"
        [disabled]="disabled"
        [ngModel]="model"
        [inline]="inline()"
        [readonlyInput]="readonlyInput()"
        [variant]="variant()"
        dateFormat="dd/mm/yy"
        (ngModelChange)="onModelChange($event)"
        [ngModelOptions]="{ standalone: true }"
    ></p-datepicker>
    <label for="{{ id() }}" class="{{ labelClassStyle() }}">{{
        label()
    }}</label>
</p-floatlabel>
